// Shared calculation engine — SAME math as backend /api/calculate.
// Runs 100% locally so every calculation works with no internet.

const round2 = (n) => Math.round(n * 100) / 100;

export function calculateMaterials(palletType, quantity) {
  let totalItems = 0;
  const components = (palletType.components || []).map((comp) => {
    const totalQty = (comp.quantity || 0) * quantity;
    totalItems += totalQty;
    return {
      name: comp.name,
      per_pallet: comp.quantity,
      total: totalQty,
      length: comp.length ?? null,
      height: comp.height ?? null,
      thickness: comp.thickness ?? null,
      notched: comp.notched ?? null,
      notch_length: comp.notch_length ?? null,
      pcs_per_min: comp.pcs_per_min || comp.minutes || null,
      board_footage: comp.board_footage ?? null,
      cost: comp.cost ?? null,
      lumber: comp.lumber
        ? comp.lumber.filter((l) => parseFloat(l.quantity) > 0).map((l) => ({
            length: l.length ?? null,
            quantity: l.quantity ? round2(totalQty / l.quantity) : 0,
            pcs_per_cant: l.quantity || 0,
            description: l.description ?? null,
            thickness: l.thickness ?? null,
            width: l.width || "6",
          }))
        : null,
      skids: comp.skids ? round2(totalQty / comp.skids) : null,
      boards_per_skid: comp.skids ? parseFloat(comp.skids) : null,
      extras: comp.extras || null,
    };
  });
  return {
    pallet_type_name: palletType.name,
    pallet_quantity: quantity,
    components,
    total_items: totalItems,
    notes: palletType.notes || null,
    image: palletType.image || null,
    images: palletType.images || null,
  };
}
